// ============================================================================
// Last words as plain text. An agent's (and Prime's) replies are markdown, drawn
// in full only in their threads (lib/mdlite.tsx); everywhere a reply is clipped
// to a line or two (Home's Prime widget, the Ask sheet, the Agents screen's rows
// and Prime's card) it is this: the words, with a diagram or a block of code
// named rather than spilled, and no markdown marks left in. Pure; tested.
// ============================================================================

/** A reply as one line of plain words: fences named, marks dropped, whitespace folded. */
export const plainWords = (text: string): string =>
  text
    // a fenced block is named for what it is: a diagram, or code
    .replace(/```[ \t]*([\w-]*)[^\n]*\n?[\s\S]*?(?:```|$)/g, (_, lang: string) =>
      lang.toLowerCase() === 'mermaid' ? ' (diagram) ' : ' (code) ',
    )
    // pictures go, links keep their words
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    // headings, quotes, list bullets and table rules at the start of a line
    .replace(/^[ \t]*#{1,6}[ \t]+/gm, '')
    .replace(/^[ \t]*>[ \t]?/gm, '')
    .replace(/^[ \t]*(?:[-*+]|\d+[.)])[ \t]+/gm, '')
    .replace(/^[ \t]*\|?[ \t]*:?-{3,}.*$/gm, '')
    .replace(/\|/g, ' ')
    // emphasis and inline code keep their words
    .replace(/(\*\*|__)(.+?)\1/g, '$2')
    .replace(/(^|[\s(])[*_]([^*_\s][^*_]*?)[*_](?=[\s).,;:!?]|$)/g, '$1$2')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/~~(.+?)~~/g, '$1')
    .replace(/\s+/g, ' ')
    .replace(/\s+([.,;:!?])/g, '$1')
    .trim()
